import { useRouter } from 'next/router'
import styled from 'styled-components'
import { ResetIcon, SearchIcon } from '@/components/domains/search/result/filter/icons'
import { GlobalColorEnum } from '@/constants/global-color.enum'
import ROUTES from '@/constants/legacy/constRoutes'
import { QueryStringKeyEnum } from '@/constants/query-string-key.enum'

const SearchResultEmpty = () => {
  const { query, replace } = useRouter()
  const {
    [QueryStringKeyEnum.FilterCategory]: filterCategory,
    [QueryStringKeyEnum.FilterBrand]: filterBrand,
    [QueryStringKeyEnum.FilterPrice]: filterPrice,
  } = query

  const isFiltered = !!(filterCategory || filterBrand || filterPrice)

  const initFilterQuery = () => {
    const _query = { ...query }
    delete _query?.[QueryStringKeyEnum.OrderBy]
    delete _query?.[QueryStringKeyEnum.FilterExcept]
    delete _query?.[QueryStringKeyEnum.FilterCategory]
    delete _query?.[QueryStringKeyEnum.FilterBrand]
    delete _query?.[QueryStringKeyEnum.FilterPrice]

    replace({
      pathname: ROUTES.SEARCH_RESULT,
      query: {
        ..._query,
      },
    })
  }

  return (
    <StyledContainer>
      <StyledImage>
        <SearchIcon />
      </StyledImage>
      <StyledNoResultText>
        {isFiltered ? '선택한 필터에 대한 검색 결과가 없습니다.' : '검색 결과가 없습니다.'}
      </StyledNoResultText>
      {isFiltered && (
        <ResetButton onClick={initFilterQuery}>
          <ResetIcon color={GlobalColorEnum.Gray900} />
          <StyledText>검색 필터 초기화</StyledText>
        </ResetButton>
      )}
    </StyledContainer>
  )
}

const StyledContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin: 8rem 0;
`
const StyledImage = styled.div`
  position: relative;
  margin-bottom: 24px;
  line-height: 0;
`

const StyledNoResultText = styled.div`
  font-size: 16px;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: -0.02em;
  color: ${({
    theme: {
      color: { gray500 },
    },
  }) => gray500};
`

const ResetButton = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 4px;
  margin-top: 24px;
  padding: 14px 16px 14px 14px;
  width: 168px;
  height: 48px;
  background: ${({
    theme: {
      color: { grayWhite },
    },
  }) => grayWhite};
  border: ${({
    theme: {
      color: { gray200 },
    },
  }) => `1px solid ${gray200};`} 
  border-radius: 8px;
  cursor: pointer;
`

const StyledText = styled.div`
  font-weight: 500;
  font-size: 16px;
  line-height: 20px;
  letter-spacing: -0.02em;
  color: ${({
    theme: {
      color: { gray900 },
    },
  }) => gray900};
`

export default SearchResultEmpty
